"use strict";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const jobRequestService = {
  getJobRequests: function () {
    return api.get("/JobRequests", WithToken.headersToken({}, configuration.cookieName));
  },
  createJobRequest: function (options) {
    return api.post("/JobRequests", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteJobRequest: function (options) {
    return api.delete("/JobRequests", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default jobRequestService;
